import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {IDateRangeReportingData} from "../../../interfaces/reporting/IDateRangeReportingData";
import {MatError, MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import {MatTabsModule} from "@angular/material/tabs";
import {
  ComprehensiveReportByDateRangeComponent
} from "../comprehensive-report-by-date-range/comprehensive-report-by-date-range.component";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {PricePointReportComponent} from "../price-point-report/price-point-report.component";
import {
  MultipleStandardGameReportsComponent
} from "../multiple-standard-game-reports/multiple-standard-game-reports.component";

@Component({
  selector: 'app-date-range-reporting',
  standalone: true,
  templateUrl: './date-range-reporting.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatButton,
    MatTabsModule,
    ComprehensiveReportByDateRangeComponent,
    MatError,
    HasPermissionDirective,
    PricePointReportComponent,
    MultipleStandardGameReportsComponent
  ],
  styleUrls: ['./date-range-reporting.component.scss', '../../../pages/reports/reports.scss',]
})
export class DateRangeReportingComponent {

  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.activeGame = gameP;
    // if the user is already looking at the reports for one game, and they change the game, then we want to just fetch the new data
    // for the new game

    if(this.showReports) {
      this.onSubmit();
    }
  }

  public comprehensiveDatesFromGroup = new FormGroup({
    startDate: new FormControl<string>("", Validators.required),
    endDate: new FormControl<string>("", Validators.required)
  });

  public dateRanges!: IDateRangeReportingData;
  public showReports = false;
  public activeGame: IGameQueryResult | null = null;
  public permissionTypes = PermissionTypes;

  onSubmit() {
    if (this.comprehensiveDatesFromGroup.invalid ) {
      this.comprehensiveDatesFromGroup.markAllAsTouched();
      return;
    }
    this.dateRanges = {
      StartDate: this.comprehensiveDatesFromGroup.controls.startDate.value!,
      EndDate: this.comprehensiveDatesFromGroup.controls.endDate.value!,
      Game: this.activeGame!
    }
    this.showReports = true;
  }

}
